import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { List, Row, Col, Button, Spin, Space, Badge } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useQuery } from '@apollo/react-hooks';
import { Link } from 'react-router-dom';
import _s from './index.less';
import Filters from './Filters';

export const Plan = ({ item, viewMode, getActions = () => null, role }) => {
  const { meta, isHidden, url = '', decorId = '', planId = '' } = item;
  const hasConfigurator = url.indexOf('configurator') > 0;
  const numberOfPublished =
    (item.photos && item.photos.filter(photo => photo.isPublish).length) || 0;

  return (
    <Row style={{ border: 'solid 1px', borderRadius: '5px', borderColor: 'lightgray' }}>
      {viewMode === 0 && (
        <Col span={24} lg={16}>
          <img
            style={{ opacity: isHidden ? 0.6 : 1.0 }}
            alt=""
            src={item.logo || item.image}
            className={_s.imageList}
            aria-hidden="true"
          />
        </Col>
      )}
      {viewMode === 1 && (
        <Col span={24} lg={16}>
          <img
            style={{ opacity: isHidden ? 0.6 : 1.0 }}
            alt=""
            src={`https://3d.homewip.com/svg/${item.planId}/`}
            className={_s.imageList}
            aria-hidden="true"
          />
        </Col>
      )}
      <Col span={24} lg={8} style={{ padding: '1.5em', flexDirection: 'column', display: 'flex' }}>
        <Row style={{ display: 'flex', flex: 1, opacity: isHidden ? 0.6 : 1.0 }}>
          <Col>
            {isHidden ? <span className={_s.metaPlanList}>Plan is hidden</span> : null}
            <span className={_s.titlePlanList}>{(item.title || 'House').toUpperCase()}</span>
            <br />
          </Col>
        </Row>
        <Row
          style={{
            paddingBottom: '50px',
            display: 'flex',
            flex: 1,
            opacity: isHidden ? 0.6 : 1.0
          }}
        >
          <Col>
            {meta.outerArea ? (
              <span className={_s.metaPlanList}>Exterior area: {meta.outerArea} sq ft</span>
            ) : null}
            {meta.totalArea ? (
              <span className={_s.metaPlanList}>Interior area: {meta.totalArea} sq ft</span>
            ) : null}
            {meta.width ? <span className={_s.metaPlanList}>Width: {meta.width}&apos;</span> : null}
            {meta.length ? (
              <span className={_s.metaPlanList}>Length: {meta.length}&apos;</span>
            ) : null}
            <br />
            {meta.bathroomCount ? (
              <span className={_s.metaPlanList}>
                Bathroom: {meta.bathroomCount} (
                {meta.bathroom && meta.bathroom.map(room => `${room.area}'`).join(', ')})
              </span>
            ) : null}
            {meta.bedroomCount ? (
              <span className={_s.metaPlanList}>
                Bedroom: {meta.bedroomCount} (
                {meta.bedroom && meta.bedroom.map(room => `${room.area}'`).join(', ')})
              </span>
            ) : null}
            {meta.kitchenCount ? (
              <span className={_s.metaPlanList}>
                Living room: {meta.kitchenCount} (
                {meta.kitchen && meta.kitchen.map(room => `${room.area}'`).join(', ')})
              </span>
            ) : null}
            <br />
            {role === 'ADMIN' && meta.type && (
              <span className={_s.metaPlanList}>Type: {meta.type}</span>
            )}
            {role === 'ADMIN' ? (
              <Row>
                <Col span={24}>
                  <List
                    size="small"
                    dataSource={[
                      { label: 'Configurator', exists: hasConfigurator },
                      { label: 'Decor', exists: Boolean(decorId) },
                      { label: 'Plan', exists: Boolean(planId) },
                      { label: 'Renders', exists: Boolean(numberOfPublished > 1) },
                      {
                        label: 'Visualizations',
                        exists: Boolean(numberOfPublished > 5)
                      }
                    ]}
                    renderItem={item => (
                      <List.Item>
                        <Space>
                          <Badge
                            color={item.exists ? '#52c41a' : '#f5222d'}
                            style={{ marginRight: '8px' }}
                          />
                          <span>{item.label}</span>
                        </Space>
                      </List.Item>
                    )}
                  />
                </Col>
              </Row>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col span={24}>{getActions(item)}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export const Plans = ({ items, viewMode, getActions, role }) => {
  const [pageSize, setPageSize] = useState(10);

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      dataSource={items}
      pagination={{
        onShowSizeChange: (page, size) => {
          setPageSize(size);
        },
        pageSize: pageSize
      }}
      renderItem={item => {
        return (
          <List.Item>
            <Plan item={item} viewMode={viewMode} getActions={getActions} role={role} />
          </List.Item>
        );
      }}
    />
  );
};

const ListContainer = props => {
  const { prefix, queries, editable = true, user } = props;
  const [filters, setFilters] = useState({});
  const [viewMode, setViewMode] = useState(0);

  const { data, refetch, loading } = useQuery(queries, {
    variables: { ...filters }
  });
  const items = (data && data[Object.keys(data)[0]]) || [];

  useEffect(() => {
    refetch();
  }, [data, filters]);

  const getActions = item => {
    const actions = [
      <Link
        className={_s.viewButton}
        style={{ background: '#FFFFFF', color: '#000000' }}
        key={`view-${item.id}`}
        to={`/${prefix}/${item.id}`}
        target="_blank"
      >
        <span>View</span>
      </Link>
    ];

    if (user.role === 'ADMIN') {
      actions.push(
        <Link
          className={_s.viewButton}
          key={`admin-view-${item.id}`}
          to={`/admin/${prefix}/view/${item.id}`}
          target="_blank"
        >
          Admin View
        </Link>
      );
    }
    if (editable) {
      actions.push(
        <Link
          className={_s.viewButton}
          style={{ left: '100px' }}
          key={`edit-${item.id}`}
          to={`/admin/${prefix}/edit/${item.id}`}
          target="_blank"
        >
          Edit
        </Link>
      );
    }
    return actions;
  };

  return (
    <div style={{ display: 'block', margin: '2em', width: '90vw' }}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Filters {...{ prefix, filters, setFilters, refetch, role: user.role }} />
        </Col>
      </Row>
      <Row style={{ marginBottom: '1em' }}>
        <Col span={4}>
          {user.role === 'ADMIN' ? (
            <Link to={`/admin/${prefix}/new`}>
              <Button type="primary">Create</Button>
            </Link>
          ) : null}
        </Col>
        {user.role === 'ADMIN' ? (
          <Col span={4} offset={16}>
            {viewMode === 0 && (
              <Button style={{ width: '100%' }} type="ghost" onClick={() => setViewMode(1)}>
                Floor Plan
              </Button>
            )}
            {viewMode === 1 && (
              <Button style={{ width: '100%' }} type="ghost" onClick={() => setViewMode(0)}>
                Doll House
              </Button>
            )}
          </Col>
        ) : null}
      </Row>
      {loading ? (
        <Row justify="center">
          <Col>
            <Spin size="large" />
          </Col>
        </Row>
      ) : (
        <Plans items={items} viewMode={viewMode} getActions={getActions} role={user.role} />
      )}
      <br />
      {user.role === 'ADMIN' && `Count: ${items.length}`}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

ListContainer.propTypes = {
  user: PropTypes.object.isRequired,
  prefix: PropTypes.string.isRequired,
  queries: PropTypes.object.isRequired,
  editable: PropTypes.bool
};

const connectedList = connect(mapStateToProps, mapDispatchToProps)(ListContainer);

export default connectedList;
